module.exports = __webpack_public_path__ + "img/creditsafe.ad4428a6.svg";